const getFullName = (value) => {
    if (value) {
        const { firstName = '', lastName = '' } = value;
        return `${firstName} ${lastName}`.trim();
    }
    return '';
};

export default getFullName;
